<template>
  <v-card :width="width" :height="height" :max-width="width" :max-height="height" flat :loading="!loaded"
    :color="!loaded ? 'grey lighten-5' : ''" class="baner-render" v-show="showBanner && (live || thumb)">
    <RibbonWatermark v-if="!watermark" :text="watermarkText" />
    <template slot="progress">
      <v-overlay absolute class="d-flex flex-column text-center" color="transparent">
        <v-progress-circular width="2" color="primary " indeterminate>
          <!-- <span>Loading</span> -->
        </v-progress-circular>
      </v-overlay>
    </template>
    <div class="size font-weight-regular " v-if="dimensions">
      {{ dimensions }}
    </div>

    <iframe sandbox="allow-scripts allow-same-origin allow-top-navigation" v-format-preview="liveUrl" frameborder="0"
      :width="width" :height="height" class="live-preview" v-if="live" ref="iframe"></iframe>
    <v-img :src="thumbName | staticFilter" contain v-if="thumb" :width="width" :height="height">
      <template v-slot:placeholder>
        <v-row class="fill-height" align="center" justify="center" no-gutters>
          <v-progress-circular :size="50" :width="3" color="primary" indeterminate></v-progress-circular>
        </v-row> </template></v-img>
  </v-card>
</template>

<script>
import PreviewService from "@/common/services/preview";
// import banner from "../../store/modules/banner";

export default {
  components: {
    RibbonWatermark: () => import("@/components/RibbonWatermark"),
  },
  name: "BannerRender",
  data() {
    return {
      live: false,
      dimension: false,
      liveUrl: "",
      thumb: false,
      thumbName: "",
      loaded: false,
      showBanner: true,
    };
  },
  computed: {
    dimensions() {
      if (this.liveUrl?.includes("/api/render/video/")) {
        return "Streaming video ad";
      }
      return `${this.width}x${this.height}`;
    },
    width() {
      return this.banner.width || this.banner.dimensions?.split("x")[0];
    },
    height() {
      return this.banner.height || this.banner.dimensions?.split("x")[1];
    },
  },
  methods: {
    onLoad() {
      try {
        // deal with older browsers
        const doc =
          this.$refs["iframe"].contentDocument ||
          this.$refs["iframe"].contentWindow.document;
        const playerInfo = doc.querySelector(".player-info");
        if (playerInfo) {
          playerInfo.style.visibility = "hidden";
        }
      } catch (err) {
        // do nothing
      }

      this.loaded = true;
    },
  },
  props: ["banner", "ommitErrors", "watermark", "watermarkText"],
  async mounted() {
    const { liveUrl, live, thumb, fileName } = this.banner;
    this.liveUrl = liveUrl || live;
    this.thumbName = thumb || fileName;
    try {
      const { status } = await PreviewService.getUrlPreview(this.liveUrl);

      if (this.ommitErrors || status !== 200) {
        this.thumb = this.thumbName ? true : false;
        this.showBanner = this.thumb;
        this.showBanner = false;
        if (this.liveUrl.toLowerCase().includes("video")) {
          return;
        }
      }
      this.loaded = true;
      this.live = true;
      this.dimension = true;
    } catch (error) {
      this.loaded = true
      this.live = false
      this.thumb = this.thumbName ? true : false;
      console.warn(error.response?.data)
      this.onLoad()
    }
    this.$emit("loaded", this.width);
  },
};
</script>
<style lang="scss" scoped>
.size {
  position: absolute;
  top: -1em;
  left: 0;
}
</style>
